export default __webpack_public_path__ + "static/026-4a57449c51c2383ad8a1c1040c5fa01d.png";